export const ICategory = {
  id: 14,
  name: 'category 1',
  images: [1, 2],
  image_type: 0,
  colour: 'FFFFFF',
  parent_id: 0,
  is_active: true,
  ord: 0,
  availability_type: 0,
  availability: {
    1: { active: true, av_id: 1 },
    2: { active: false },
  },
  subcategories: [{ id: 20, name: 'sub-cat-1' }],
  last_user_id: 32,
  is_archive: false,
  created_at: '2023-10-13T09:32:45.156Z',
  updated_at: '2023-10-13T09:32:45.156Z',
  archived_at: null,
}

export const ICategoryOverride = {
  id: 13,
  main_id: 14,
  store_id: 56,
  id2: '',
  id2_type: 0,
  is_active: true,
  ord: 0,
  availability_type: 0,
  availability: { 1: { active: true, av_id: 2 } },
  last_user_id: 32,
  is_archive: false,
  created_at: '2023-10-13T09:32:45.156Z',
  updated_at: '2023-10-13T09:32:45.156Z',
  archived_at: null,
}

export const ICategoryUpsertArgs = {
  id: 2,
  store_id: 56,
  name: 'category 1',
  image: [1, 2],
  image_type: 0,
  colour: 'FFFFFF',
  parent_id: 0,
  ord: 0,
  availability_type: 0,
  subcategories: [{ id: 0, name: 'sub1', is_archive: false }],
  availability: {
    1: { active: true, av_id: 2 },
    2: { active: true },
  },
}
